import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 5.5,
		cy: 5.5,
		r: 4.9,
		stroke: "currentColor",
		strokeWidth: .92
	})
});
export default SvgCircleOutline;
